import loadingGif from '@/assets/loading.gif'

interface Props {
  height?: string
}

export default function Loading({ height = '100vh' }: Readonly<Props>) {
  return (
    <div
      data-testid="loadingGif"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height,
      }}
    >
      <img src={loadingGif} alt="loading" />
    </div>
  )
}
